import Switch from '@jbhi-fi/lanyard-ui/components/Switch';
import React from 'react';
import { styles } from './ToggleButtonRefinement.css';
import { useClearRefinements, useToggleRefinement } from 'react-instantsearch';

export type ToggleButtonRefinementProps = {
  facet: string;
  label: string;
  valueWhenChecked: boolean;
  onToggle: (isChecked: boolean) => void;
  isSearchPage?: boolean;
};

export const ToggleButtonRefinement = ({
  label,
  facet,
  valueWhenChecked,
  onToggle,
  isSearchPage = false,
}: ToggleButtonRefinementProps) => {
  // `hasProductsAfterRefining` will be false if toggling removes *all* products
  // `hasProductsToRefine` will be false if `onFacetValue` and `offFacetValue` have the same `count`
  // which means there are no products to refine
  // if either are false, hide the component

  const {
    refine: toggleRefinement,
    canRefine: hasProductsAfterRefining,
    value,
  } = useToggleRefinement({
    attribute: facet,
    on: valueWhenChecked,
  });

  const hasProductsToRefine = !(value?.offFacetValue?.count === value?.onFacetValue?.count);

  const canRefine = hasProductsAfterRefining && hasProductsToRefine;

  const { refine: clearRefinements } = useClearRefinements({ includedAttributes: [facet] });

  const handleToggle = (isChecked: boolean) => {
    if (isChecked) {
      toggleRefinement({ isRefined: valueWhenChecked });
    } else {
      clearRefinements();
    }
    onToggle(isChecked);
  };

  if (!canRefine) return null;

  return (
    <div className={styles.container({ isSearchPage: isSearchPage })}>
      <Switch label={label} onToggle={handleToggle} isMobileFullSize classes={styles.toggleButton({ isSearchPage })} />
    </div>
  );
};
